import React, { Component } from 'react';
import Select from 'react-select';

import MasterDataUserAlert from './MasterDataUserAlert';

class MasterDataUserThirdPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showWarningAlertRole: false,
            showWarningAlertDataGroup: false
        }
    }

    handleChangeRole = async e => {
        await this.props.handleChangeRole(e)
        this.setState({ showWarningAlertRole: false })
    }

    handleChangeDataGroup = async e => {
        await this.props.handleChangeDataGroup(e)
        this.setState({ showWarningAlertDataGroup: false })
    }

    handleSubmit = async () => {
        await this.setState({
            showWarningAlertRole: false,
            showWarningAlertDataGroup: false
        })

        if (this.props.role.value === '') {
            return this.setState({ showWarningAlertRole: true })
        }

        if (this.props.dataGroup.value === '') {
            return this.setState({ showWarningAlertDataGroup: true })
        }

        this.props.handleSubmit()
    }

    render() {
        return (
            <div className="w-full bg-white rounded-b-2xl px-5 py-10 mb-10 relative calculate-layout-user">
                <div className="flex pb-10 border-b-2 border-gray mb-10" style={{ height: "90%" }}>
                    <div className="w-1/2">
                        <div className="box-1 p-5">
                            <div className="flex mb-4">
                                <div className="w-1/6 text-right font-bold mr-5 flex justify-end">
                                    <p className="mr-1">Peran </p>
                                    {this.props.action !== 'detail' && <span className="text-darkred">*</span>}
                                </div>
                                <div className="w-5/6">
                                    <Select
                                        id="ddsrole"
                                        placeholder="Pilih Peran"
                                        value={this.props.role.value}
                                        options={this.props.role.data}
                                        onChange={this.handleChangeRole}
                                        onInputChange={this.props.handleSearchRole}
                                        isDisabled={this.props.action === "detail"}
                                    />
                                    {this.state.showWarningAlertRole && this.props.action !== 'detail' && <MasterDataUserAlert text="Peran tidak boleh kosong!" />}
                                </div>
                            </div>

                            <div className="flex mb-4">
                                <div className="w-1/6 text-right font-bold mr-5 flex justify-end">
                                    <p className="mr-1">Data Group </p>
                                    {this.props.action !== 'detail' && <span className="text-darkred">*</span>}
                                </div>
                                <div className="w-5/6">
                                    <Select
                                        id="ddsdatagroup"
                                        placeholder="Pilih Data Group"
                                        value={this.props.dataGroup.value}
                                        options={this.props.dataGroup.data}
                                        onChange={this.handleChangeDataGroup}
                                        onInputChange={this.props.handleSearchDataGroup}
                                        isDisabled={this.props.action === "detail"}
                                    />
                                    {this.state.showWarningAlertDataGroup && this.props.action !== 'detail' && <MasterDataUserAlert text="Data Group tidak boleh kosong!" />}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="absolute bottom-5 right-5">
                    <button type="button" id="btnback" className="bg-white rounded text-darkblue border border-darkblue focus:outline-none w-32 py-2 mt-3 mr-2" onClick={() => this.props.handleChangePage(2)}>Sebelumnya</button>
                    <button type="submit" id="btnnext" className="bg-lightblue rounded text-white border border-lightblue focus:outline-none w-32 py-2 mt-3 ml-2" onClick={() => this.handleSubmit()}>{this.props.action === "add" ? "Tambah" : this.props.action === "edit" ? "Ubah" : "Tutup"}</button>
                </div>
            </div>
        );
    }
}

export default MasterDataUserThirdPage;